import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

/**
 * Integrations section — read-only empty state.
 *
 * External integrations (SIEM, ticketing, SSO) are provisioned by an
 * administrator; end users have no self-service controls here yet. Rather
 * than show a `Coming soon` stub or a button that does nothing, present an
 * explanation so users know where to go next.
 */
export function IntegrationsSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Integrations</CardTitle>
        <CardDescription>
          External integrations (SIEM, ticketing, SSO) are managed by your
          administrator. Contact your admin to request additional integrations.
        </CardDescription>
      </CardHeader>
    </Card>
  )
}
